import { Measurement } from './measurement';

/* tslint:disable:no-console */

export default class MeasurementManager {

    private dbName: string = 'SenTiLab';
    private dbVersion: number = 1;
    private storeName: string = 'measurements';

    // public constructor() {
    // }

    public async save(measurement: Measurement) {
        let connection: any;
        connection = await this.connect(this.dbName, this.dbVersion);
        return this.storeToDatabase(connection, measurement);
    }

    public async getAllMeasurements() {
        return new Promise(async (resolve, reject) => {
            let connection: any;
            connection = await this.connect(this.dbName, this.dbVersion);

            const tx = connection.transaction([this.storeName], 'readonly');
            const store = tx.objectStore(this.storeName);

            const items: any[] = [];
            const request = store.openCursor();

            request.onsuccess = (event: any) => {
                const cursor = event.target.result;
                if (cursor) {
                    items.push(cursor.value);
                    cursor.continue();
                } else {
                    resolve(items);
                }
            };
            request.onerror = () => reject(request.error);
        });
    }

    public async deleteMeasurement(measurement: Measurement) {
        return new Promise(async (resolve, reject) => {
            let connection: any;
            connection = await this.connect(this.dbName, this.dbVersion);

            const tx = connection.transaction([this.storeName], 'readwrite');
            const store = tx.objectStore(this.storeName);

            const request = store.delete(measurement.timestamp);

            request.onsuccess = (event: any) => { resolve(); };
            request.onerror = () => reject(request.error);
        });
    }

    private connect(name: string, version: number) {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(name, version);
            request.onupgradeneeded = (event: any) => {
                const db = event.target.result;
                db.createObjectStore(this.storeName);
                console.log('IndexedDB upgrade needed');
            };
            request.onsuccess = () => resolve(request.result);
            request.onerror = () => reject(request.error);
            request.onblocked = () => { console.log('Connection to IndexedDB is blocked'); };
        });
    }

    // IDBOpenDBRequest
    private storeToDatabase(connection: any , measurement: Measurement) {
        return new Promise((resolve, reject) => {
          const tx = connection.transaction([this.storeName], 'readwrite');
          const store = tx.objectStore(this.storeName);
          const request = store.put(measurement, measurement.timestamp);
          request.onsuccess = () => resolve(request.result);
          request.onerror = () => reject(request.error);
        });
    }
}
